module.exports = __webpack_public_path__ + "img/icon_beer.b1c7f056.png";